.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  min-height: 44px;
  padding: 0 var(--space-5);
  border: 1px solid transparent;
  border-radius: var(--radius-md);
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  transition:
    background var(--transition),
    transform var(--transition),
    box-shadow var(--transition);
  user-select: none;
}
.button:active:not(:disabled) {
  transform: scale(0.98);
}
.button:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
.primary {
  background: var(--color-primary);
  color: var(--color-on-primary);
}
.primary:hover:not(:disabled) {
  background: var(--color-primary-hover);
}
.help {
  background: var(--color-help);
  color: #fff;
}
.help:hover:not(:disabled) {
  background: var(--color-help-hover);
}
.secondary {
  background: var(--color-surface);
  border-color: var(--color-border);
}
.secondary:hover:not(:disabled) {
  background: var(--color-surface-2);
}
.ghost {
  background: transparent;
}
.ghost:hover:not(:disabled) {
  background: var(--color-surface-2);
}
.danger {
  background: transparent;
  color: var(--color-danger);
  border-color: color-mix(in srgb, var(--color-danger) 35%, transparent);
}
.sm {
  min-height: 36px;
  padding: 0 var(--space-3);
  font-size: var(--text-sm);
}
.lg {
  min-height: 56px;
  font-size: var(--text-lg);
  border-radius: var(--radius-lg);
}
.block {
  width: 100%;
}
.spinner {
  width: 18px;
  height: 18px;
  border: 2px solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.iconButton {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border: none;
  border-radius: var(--radius-full);
  background: transparent;
  cursor: pointer;
  font-size: 20px;
}
.iconButton:hover {
  background: var(--color-surface-2);
}
.soft {
  background: var(--color-primary-soft);
  border-color: var(--color-primary);
  color: var(--color-text);
}
.soft:hover:not(:disabled) {
  filter: brightness(0.96);
}
